export const guestAppConfig = {
  applicationName: 'Tov+ Guest Experience',
  supportEmail: 'hello@tovplus.com',
  marketingUrl: 'https://tovplus.com',
  docsUrl: 'https://docs.tovplus.com',
  publicSiteUrl: 'https://tov.plus',
  localSiteUrl: 'http://127.0.0.1:4176',
} as const;

function normalizeGuestSitePath(path: string | undefined): string {
  if (!path || path === '/') {
    return '';
  }

  return path.startsWith('/') ? path : `/${path}`;
}

export function resolveGuestSiteOrigin(browserOrigin?: string): string {
  const globalObject = globalThis as typeof globalThis & {
    location?: { origin?: string };
  };
  const globalLocationOrigin =
    typeof globalObject.location?.origin === 'string'
      ? globalObject.location.origin
      : undefined;

  const currentOrigin = browserOrigin?.trim().length
    ? browserOrigin.trim()
    : (globalLocationOrigin ?? guestAppConfig.publicSiteUrl);

  try {
    const currentUrl = new URL(currentOrigin);
    const { hostname, protocol } = currentUrl;

    if (hostname === '127.0.0.1' || hostname === 'localhost') {
      return guestAppConfig.localSiteUrl;
    }

    if (hostname.endsWith('.tovplus.local')) {
      return `${protocol}//guests.tovplus.local`;
    }

    if (
      hostname.startsWith('release-stage-') &&
      hostname.endsWith('.tovplus.com')
    ) {
      return `${protocol}//release-stage-guests.tovplus.com`;
    }

    return guestAppConfig.publicSiteUrl;
  } catch {
    return guestAppConfig.publicSiteUrl;
  }
}

export function buildGuestSiteUrl(input: {
  occasionSlug: string;
  path?: string;
  browserOrigin?: string;
  query?: Record<string, string | number | boolean | null | undefined>;
}) {
  const origin = resolveGuestSiteOrigin(input.browserOrigin);
  const url = new URL(
    `/${encodeURIComponent(input.occasionSlug)}${normalizeGuestSitePath(
      input.path,
    )}`,
    origin,
  );

  for (const [key, value] of Object.entries(input.query ?? {})) {
    if (value === null || value === undefined || value === '') {
      continue;
    }

    url.searchParams.set(key, String(value));
  }

  return url.toString();
}
